import { Header, Modal } from '@procurify/ui'
import { useSelector } from 'react-redux'

import { makeSelectFeatureSwitches } from '@webapp/core/stores/global'
import { useProcurifyIntl } from '@webapp/hooks'
import { BudgetCategoryExporter } from './BudgetCategoryExporter'
import messages from './messages'

export interface BudgetCategoryExporterModalProps {
  open?: boolean
  onDismiss?(): void
}

export const BudgetCategoryExporterModal = ({
  open = false,
  onDismiss = () => undefined,
}: BudgetCategoryExporterModalProps) => {
  const intl = useProcurifyIntl()
  const { enable_flexible_spend_tracking: isFlexibleSpendTrackingEnabled } =
    useSelector(makeSelectFeatureSwitches())

  return (
    <Modal
      maxWidth='md'
      open={open}
      onClose={onDismiss}
      aria-labelledby='budget-categories-export-modal-title'
    >
      <Modal.Card>
        <Modal.Header onClose={onDismiss}>
          <Header as='h5' id='budget-categories-export-modal-title'>
            {intl.formatMessage(
              isFlexibleSpendTrackingEnabled
                ? messages.budgetsExporterModalTitle
                : messages.budgetCategoryExporterModalTitle
            )}
          </Header>
        </Modal.Header>
        <Modal.Content>
          <BudgetCategoryExporter handleModalClose={onDismiss} />
        </Modal.Content>
      </Modal.Card>
    </Modal>
  )
}
